module.exports = __webpack_public_path__ + "img/proof_awards_gold.5d04b341.png";